import {observable} from 'mobx';

class Errors {
  @observable type ={
    duplicate:'Duplicated',
    empty:'This field is required.',
    maxLength: length=> `The maximum length is ${length}.`,
    reachLimits:'You have reach event quantity limits.'
  }
}
var errors = new Errors;

export default errors;



// WEBPACK FOOTER //
// ./src/store/errors.js